// eslint-disable-next-line @typescript-eslint/no-unused-vars
import React from "react";
import { GatsbyBrowser } from "gatsby";
import CssBaseline from "@mui/material/CssBaseline";
import "@fontsource/montserrat/400.css";
import "@fontsource/montserrat/600.css";
import "@fontsource/montserrat/700.css";
import "@fontsource/roboto-slab/400.css";
import "@fontsource/roboto-slab/700.css";
import AppThemeProvider from "./src/components/AppThemeProvider";

export const wrapRootElement: GatsbyBrowser["wrapRootElement"] = ({ element }) => (
  <AppThemeProvider>
    <CssBaseline />
    {element}
  </AppThemeProvider>
);
